<div class="title-container">
    <div class="title-block">
        <span>{{title}}</span>
        <a *ngIf="helpUrl"
                href="{{helpUrl}}"
            target="_blank" rel="noreferrer noopener">
            <mat-icon class="material-icons-outlined">help_outline</mat-icon>
        </a>
    </div>
    <div>
        <division-selector></division-selector>
        <mat-slide-toggle
            *ngIf="showToggle"
            [color]="'accent'"
            [checked]="toggleChecked"
            (toggleChange)="emitToggleChange()"
            [aria-label]="toggleTitle"
        >{{toggleTitle}}</mat-slide-toggle>
    </div>
</div>
